import type {GlobalConfig} from "./types";
import {PageType} from "./types";

export const GLOBAL_CONFIG: GlobalConfig = {
    mainSettings: {
        grade: "Физика. 9 класс",
        subject: "Методические особенности изучения темы «Закон преломления света»",
        mainColor: "./images/bg_img.png",
        secondColor: "rgba(250, 219, 187, 0.8)",
    },
    home: {
        title: "Методические особенности изучения темы «Закон преломления света»",
        authorsTitle: "Автор",
        authors: [
            {
                author: "Пчёлкина М.А.",
                grade: "научный сотрудник",
                subGrade: " ",
                imageSrc: "./images/author_1.png"
            },
            {
                author: "Никифоров Г.Г.",
                grade: "к.пед.н.",
                subGrade: " ",
                imageSrc: "./images/author_2.png"
            },
            {
                author: "Андреева Н.В.",
                grade: "почётный работник ОО РФ",
                subGrade: " ",
                imageSrc: "./images/author_3.png"
            }
        ],
        imagePath: "./images/title_img.png",
    },
    pages: [
        {
            order: 1,
            nextBtnName: "Далее",
            pdfPath: "./files/additional_information.pdf",
            type: PageType.ANNOTATION,
            imagePath: "",
            content: [
                {
                    type: "block",
                    children: [
                        {
                            type: "block",
                            text: "<div style='background: #E7F1FF; border-radius: 16px; padding: 2.4rem; padding-bottom: 0'><p> Согласно новой Примерной рабочей программе по физике, тема «Преломление света. Закон преломления света» изучается в 9 классе. Перенос этой темы (в составе раздела «Световые явления») из 8-го класса в 9-й является методически оправданным, так как в 8 классе обучающиеся ещё не владеют необходимым для глубокого понимания закона преломления света математическим аппаратом – тригонометрические функции в достаточном объёме ещё не введены. Кроме того, физический смысл показателя преломления раскрывался и ранее в 9 классе, а такое дробное изучение темы не способствовало её глубокому усвоению.</p></div>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Новая последовательность расположения материала позволяет учителю организовать изучение закона преломления света обучающимися в ходе самостоятельного исследования – что является непростой, но интересной задачей. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Методическая сложность при изучении темы состоит также в том, что взаимосвязь явлений отражения и преломления света невозможно показать в рамках геометрической оптики, и школьники зачастую рассматривают явления на границе раздела двух сред (отражение, преломление, поглощение) изолированно. Эта связь обнаруживается при применении закона сохранения энергии. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В настоящем методическом кейсе будет показано, как организовать изучение темы «Преломление света. Закон преломления света» на основе научного метода познания через самостоятельные эксперименты девятиклассников. </p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Будет продемонстрировано, как опыт неподтверждения выдвинутой гипотезы становится для учеников отправной точкой для нового цикла научного познания – что позволяет в итоге прийти к самостоятельному «переоткрытию» нового знания и создаёт на уроке атмосферу настоящего научного поиска.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>Также будет предложена методика применения энергетического подхода при изучении законов распространения света. Учитель сможет убедиться, что использование этой методики с опорой на закон сохранения энергии даёт возможность школьникам охватывать световые явления, возникающие на границе раздела двух сред, комплексно, а не изолированно. Это способствует более глубокому пониманию световых явлений, а также позволяет более чётко осознавать границы применимости понятий геометрической оптики.</p>"
                        },
                        {
                            type: "block",
                            text: "<p style='padding-left: 2.4rem;'>В кейсе будет показано, как:</p>" +
                                "<ul>" +
                                "<li>организовать самостоятельное исследование обучающихся по выявлению прямой пропорциональной зависимости между синусами углов падения и преломления (закона преломления света);</li>" +
                                "<li>организовать экспериментальную проверку закона сохранения энергии света на границе раздела двух сред с использованием датчика освещённости (применение энергетического подхода);</li>" +
                                "<li>провести эксперимент по обнаружению школьниками явления полного внутреннего отражения света;</li>" +
                                "<li>провести модельный эксперимент, иллюстрирующий изменение скорости распространения света на границе раздела двух сред («опыт Перельмана» по выяснению физического смысла показателя преломления).</li>" +
                                "</ul>"
                        },
                    ]
                }
            ]
        },
        {
            order: 2,
            nextBtnName: "Далее",
            type: PageType.METHODOLOGICAL_MODULE,
            title: "Методические рекомендации",
            imagePath: "",
            id: "1",
            videoUrl: "./video/video.mp4",
            contentBefore: [{
                type: "text",
                text: ``
            }],
            contentAfter: [{
                type: "text",
                text: ``
            }]
        },
        {
            order: 3,
            nextBtnName: "Далее",
            type: PageType.INTERACTIVE,
            id: "1011",
            title: "Практический модуль",
            htmlPath: "./interactive/dist/index.html",
            autoHeight: false
        },
        {
            order: 4,
            nextBtnName: "Далее",
            type: PageType.ADDITIONAL_MATERIALS,
            imagePath: "",
            materials: [
                //   {link: "https://www.youtube.com/embed/CaaH2dUJqf8", title: "Последние загадки Гизы: египетские пирамиды"},
                //  {link: "https://www.youtube.com/embed/Mg7h_qYjs9k", title: "Тайна египетских пирамид Гизы"},
                //  {link: "https://www.youtube.com/embed/MVCTEz-2I0E", title: "Ленские столбы: заповедник"}
            ],
            literatures: [
                "Ландсберг Г. С. Оптика: учебное пособие для студентов физических специальностей высших учебных заведений. – 6-е изд. – Москва: Физматлит, 2010 ",
                "Разумовский В. Г., Майер В. В. Физика в школе. Научный метод познания и обучение. – Москва: Гуманитар. изд. центр ВЛАДОС, 2004",
                "Сивухин Д. В. Общий курс физики: учеб. пособие для вузов. В 5 т. – 3-е изд. – Москва: Физматлит, 2005. Т. 4: Оптика",
                "Физика: учеб. для уч-ся 9 кл. общеобразов. учреждений / В. Г. Разумовский, В. А. Орлов, Ю. И. Дик, Г. Г. Никифоров, В. Ф. Шилов / под ред. В. Г. Разумовского, В. А. Орлова. – Москва: Гуманитар. изд. центр ВЛАДОС, 2004",
                "Элементарный учебник физики: учеб. пособие. В 3 т. / под ред. Г. С. Ландсберга. – 13-е изд. – Москва: Физматлит, 2009. Т. 3: Колебания и волны. Оптика. Атомная и ядерная физика",
            ],
            sites: [],
            filesToDownload: [
                {link: "./files/additional_information.pdf", fileName: "В чем ценность открытия электромагнитной индукции для каждого"},
            ]
        }
    ],
};
